import "./ModalHistory.scss";
import React, { useEffect, useState } from "react";
import { Modal, Loading } from "App/Component/ui";
import { instance4 } from "App/constants";
import { defaultTimeDisplay, defaultDayDisplay, defaultToastError, isNull } from "App/utils/helpers";
import { Grid } from "@material-ui/core";

export default function ModalHistory({
  showModal,
  title,
  width = "fit-content",
  maxWidth="700px",
  type = "",
  id = null,
  url,
  config = {
    status_name: "status_name",
    remark: "remark",
    createdBy: "createdBy",
    createdAt: "createdAt",
  },
}) {
  const [loading, setLoading] = useState(false);
  const [dataHistory, setDataHistory] = useState([]);

  useEffect(() => {
    (async () => {
      await fetchDataHistory(id);
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchDataHistory = async (ID) => {
    if (isNull(ID)) {
      setDataHistory([]);
    } else {
      setLoading(true);
      try {
        const api = await instance4.get(`${url}/${ID}`);
        const res = api.data;
        if (res.status === 200) {
          setDataHistory(res.data);
        } else {
          setDataHistory([]);
          defaultToastError(res.message);
        }
      } catch (error) {
        return {
          state: false,
          message: error?.response?.data?.message,
        };
      }
      setLoading(false);
    }
  };
  console.log("Data ", Object.keys((dataHistory)));

  return (

    <Modal title={title} width={width} maxWidth={maxWidth} show={showModal}>
      <Loading show={loading} />
      <Grid container spacing={1}>
        <Grid item>
          { 
            dataHistory.length > 0 ? (
            <div className="history-tl-container">
              <ul className="tl">
                {
                  Object.entries((dataHistory)).map((value, keys) => {
                  return <HistoryRender key={keys} item={value} config={config}/>;
                })}
              </ul>
            </div>
          ) : (
            <>
              <div style={{ textAlign: "center", width: "100%" }}>
                <>TIDAK ADA DATA HISTORY</>
              </div>
            </>
          )}
        </Grid>
      </Grid>
    </Modal>
  );
}

const HistoryRender = ({ key, item, config }) => {
  return (
    <>
      {item[0] == 0 ? // eslint-disable-line 
      <> 
      <li className="t0 tl-item" ng-repeat="item in retailer_history">
        <div className="timestamp">
          {defaultDayDisplay(item[1][config.createdAt])}
          <br /> {defaultTimeDisplay(item[1][config.createdAt])}
        </div>
        <div className="item-title">{item[1][config.status_name]}</div>
        <div className="item-detail">{isNull(item[1][config.remark]) ? "Tidak ada keterangan" : item[1][config.remark]} <br/><b>Oleh {item[1][config.createdBy]}</b></div>
      </li>
      </> : <>
      <li className="tl-item" ng-repeat="item in retailer_history">
        <div className="timestamp">
        {defaultDayDisplay(item[1][config.createdAt])}
          <br /> {defaultTimeDisplay(item[1][config.createdAt])}
        </div>
        <div className="item-title">{item[1][config.status_name]}</div>
        <div className="item-detail">{isNull(item[1][config.remark]) ? "Tidak ada keterangan" : item[1][config.remark]} <br/><b>Oleh {item[1][config.createdBy]}</b></div>
      </li>
      </>}
    </>
  );
};
